module.exports = __webpack_public_path__ + "img/sidenav-item-seller-records.2a62f493.svg";